import {
  LOAD_COMPLIANCE,
  LOAD_FRAMEWORKS,
  ADD_COMMENT,
  UPLOAD_FILE,
  ADD_ACTIVITY,
  LOAD_ACTIVITY,
  LOAD_SUMMARY,
  LOAD_ENABLED_FRAMEWORKS,
  SET_LOADING_STATE,
  LOAD_USERS
} from '../actions/complianceActions'

export default function (state = {}, action) {
  switch (action.type) {
    case LOAD_COMPLIANCE:
      return { ...state, controls: action.controls }
    case ADD_COMMENT:
      return { ...state, comment: action.comment }
    case UPLOAD_FILE:
      return { ...state, file: action.file }
    case ADD_ACTIVITY:
      return { ...state, activities: action.activities }
    case LOAD_ACTIVITY:
      return { ...state, activities: action.activities }
    case LOAD_SUMMARY:
      return { ...state, summary: action.payload }
    case LOAD_FRAMEWORKS:
      return { ...state, frameworks: action.payload }
    case LOAD_ENABLED_FRAMEWORKS:
      return { ...state, enabledFrameworks: action.payload }
    case SET_LOADING_STATE:
      return { ...state, loading: action.payload }
    case LOAD_USERS:
      return { ...state, users: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/complianceReducer.js